import { render } from "./EventsGeneral.vue?vue&type=template&id=1fdaba0b&scoped=true"
import script from "./EventsGeneral.vue?vue&type=script&lang=js"
export * from "./EventsGeneral.vue?vue&type=script&lang=js"

import "./EventsGeneral.vue?vue&type=style&index=0&id=1fdaba0b&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fdaba0b"]])

export default __exports__